module.exports = __webpack_public_path__ + "static/media/extra-co2.7472cdc5.png";